import {FC} from 'react'
import {ProductThumb} from '../../components/common/ProductThumb'
import {useIntl} from 'react-intl'
import {ILossOfOpportunityModel} from "../products/cors/_models";
import {storeCurrencyLabel} from '../common/currencyLabel'

type IProps = {
    item: ILossOfOpportunityModel,
    showDetails: (params?: ILossOfOpportunityModel) => void
}

const LossOfOpportunityTableRow: FC<IProps> = ({item, showDetails}) => {
    const {formatMessage} = useIntl()

    return (
        <tr>
            <th>
                <ProductThumb src={item.image} className='table-img'/>
            </th>
            <td>{item.product_name}</td>
            <td>{item.barcode}</td>
            <td>{item.model}</td>
            <td>{item.po_id}</td>
            <td>{formatMessage({id: item.remove_reason})}</td>
            <td> {item.removed_quantity}</td>
            <td>{item.total_cost} {storeCurrencyLabel(formatMessage)} </td>
            <td>{item.availability_fees} {storeCurrencyLabel(formatMessage)} </td>
            <td>{item.date_added}</td>
        </tr>
    )
}

export default LossOfOpportunityTableRow
